import React from 'react';
import '../stylesheets/account.scss';



class HelpAccount extends React.Component {

  render() {
    const itemHelpAccount = [
      'Help'
    ];
    return (
      <div className='help-account-right-container'>
        <div className='help-account-right-items-container'>
          <ul className='help-account-right-items-ul'>
            {
              itemHelpAccount.map((item) =>
                <li className='help-account-right-item-li'>
                  {item}
                </li>
              )
            }
          </ul>
        </div>
        <div className='help-account-right-items-description-container'>

        </div>
      </div>
    );
  }
};

export default HelpAccount;